import React from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../actions/actions';
import { addEntry } from './../firebase';
import { EMAIL_RECIPIENT, BCC_RECIPIENT } from '../constants';
import * as firebase from 'firebase/app';
import { sendEmail } from '../utils/sendEmail';

// Environment variables
const apiUrl = process.env.REACT_APP_API_URL;
const recaptchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

class Form extends React.Component {

  // helper to safely get recaptcha token
  getRecaptchaToken = async () => {
    return new Promise((resolve, reject) => {
      if (!window.grecaptcha) {
        reject('reCAPTCHA not loaded');
        return;
      }
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(recaptchaKey, { action: 'submit' })
          .then(resolve)
          .catch(reject);
      });
    });
  };

  onFormSubmit = async (values) => {
    const items = this.props.items;

    const formValues = Object.keys(values).map(key => `${key}: ${values[key]}`);

    const details = {
      method: 'smtp2go',
      auth_method: 'frontend',
      domain: 'materialised.com.au',
      host: 'mail.smtp2go.com',
      port: 2525,
      domain: 'materialised-art-frame.app',
      from: 'noreply@materialised-art-frame.app',
      to: EMAIL_RECIPIENT,
      cc: values.email,
      bcc: BCC_RECIPIENT,
      subject: `New image library enquiry`,
      name: values.name,
      content: `<p>Enquiry details:</p>
        <ul>${formValues.map(val => `<li>${val}</li>`).join('')}</ul>
        <p>Items:</p>
        <ul>${items.map(val => `
          <li>
            <p>Print type: ${val.selectedPrintType}</p>
            <p>Quantity: ${val.quantity}</p>
            <p>Print size: ${val.selectedSize}</p>
            <p>Frame type: ${val.selectedFrameOption}</p>
            <p>Frame orientation: ${val.selectedFrameOrientation}</p>
            <p><a href="${val.link}">Print URL: ${val.link}</a></p>
            <p>Print SKU: ${val.sku}</p>
            ${val.addWhitePaperBoard ? `<p>Add white paper board: true</p>` : ''}
            ${val.addAntiReflection ? `<p>Add anti reflection: true</p>` : ''}
            ${val.addSecurityFixtures ? `<p>Add security fixtures: true</p>` : ''}
          </li>`).join('')}
        </ul>`
    };

    // Save submission to Firestore for admin review
    await addEntry({
      ...details,
      items,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });

    // ✅ Fetch reCAPTCHA token
    const token = await this.getRecaptchaToken();


    // ✅ Send via your sendEmail utility
    const result = await sendEmail({ ...details, token });

    return result;

  };

  validate = values => {
    let errors = {};
    if (
      !values.email ||
      !values.name ||
      !values.company_name ||
      !values.abn ||
      !values.phone
    ) {
      errors.message = 'Please fill out all of the required fields';
    }
    return errors;
  };

  render() {
    return (
      <>
        <h4 className="widget-title">Please enter your details</h4>

        <Formik
          initialValues={{
            name: '',
            company_name: '',
            abn: '',
            email: '',
            phone: '',
            project_name: '',
            address: '',
            additional_comments: '',
          }}
          validate={this.validate}
          onSubmit={(values, { setSubmitting }) => {
            this.props.actions.hideToast();

            this.onFormSubmit(values)
              .then(() => {
                setSubmitting(false);
                this.props.actions.showToast('Thank you, your enquiry has been received 🎉');
                setTimeout(() => this.props.actions.hideToast(), 10000);
              })
              .catch((err) => {
                console.error('Form submission failed:', err);
                setSubmitting(false);
                this.props.actions.showToast('Error sending enquiry. Please try again later.');
                setTimeout(() => this.props.actions.hideToast(), 10000);
              });
          }}
        >
          {({
            values,
            errors,
            handleChange,
            handleSubmit,
            isSubmitting,
          }) => (
            <form
              onSubmit={handleSubmit}
              className={`grid-2 ${isSubmitting ? 'is-loading' : ''}`}
            >
              <div className="span-2 error-message">{errors.message}</div>

              <div>
                <label>Your name *</label>
                <input name="name" type="text" value={values.name} onChange={handleChange} />
              </div>

              <div>
                <label>Company name *</label>
                <input name="company_name" type="text" value={values.company_name} onChange={handleChange} />
              </div>

              <div>
                <label>ABN *</label>
                <input name="abn" type="text" value={values.abn} onChange={handleChange} />
              </div>

              <div>
                <label>Email *</label>
                <input name="email" type="email" value={values.email} onChange={handleChange} />
              </div>

              <div>
                <label>Phone *</label>
                <input name="phone" type="tel" value={values.phone} onChange={handleChange} />
              </div>

              <div>
                <label>Delivery Address</label>
                <input name="address" type="text" value={values.address} onChange={handleChange} />
              </div>

              <div>
                <label>Project name</label>
                <input name="project_name" type="text" value={values.project_name} onChange={handleChange} />
              </div>

              <div className="span-2">
                <label>Additional comments</label>
                <textarea name="additional_comments" value={values.additional_comments} onChange={handleChange}></textarea>
              </div>

              <button className="pointer btn span-2" type="submit" disabled={isSubmitting}>
                {!isSubmitting ? 'Request a quote' : 'Requesting'}
              </button>
            </form>
          )}
        </Formik>
      </>
    );
  }
}

const mapStateToProps = state => ({
  items: state.reducer.items,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
